import apiClient from '../lib/api';

export interface BetaSignupPayload {
  id?: string;
  full_name?: string;
  email?: string;
  phone?: string;
  marketing_consent?: boolean;
  has_facebook?: boolean;
  business_type?: string;
  monthly_appointments?: string;
  calendar_system?: string;
  phone_os?: string;
  booking_method?: string;
  is_fully_submitted?: boolean;
}

export interface BetaSignupResponse {
  id: string;
  message: string;
}

export const submitBetaSignup = async (data: BetaSignupPayload): Promise<BetaSignupResponse> => {
  const payload: Record<string, unknown> = {};
  if (data.id !== undefined) payload.id = data.id;
  if (data.full_name !== undefined) payload.full_name = data.full_name;
  if (data.email !== undefined) payload.email = data.email;
  if (data.phone !== undefined) payload.phone = data.phone;
  if (data.marketing_consent !== undefined) payload.marketing_consent = data.marketing_consent;
  if (data.has_facebook !== undefined) payload.has_facebook = data.has_facebook;
  if (data.business_type !== undefined) payload.business_type = data.business_type;
  if (data.monthly_appointments !== undefined) payload.monthly_appointments = data.monthly_appointments;
  if (data.calendar_system !== undefined) payload.calendar_system = data.calendar_system;
  if (data.phone_os !== undefined) payload.phone_os = data.phone_os;
  if (data.booking_method !== undefined) payload.booking_method = data.booking_method;
  if (data.is_fully_submitted !== undefined) payload.is_fully_submitted = data.is_fully_submitted;

  const response = await apiClient.post<BetaSignupResponse>('/api/beta-signup', payload);
  return response.data;
};
